import { Injectable } from '@angular/core';
import { Exam } from '../_models/Exam';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { AlertifyService } from '../_services/alertify.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ExamService } from '../_services/exam.service';

@Injectable()
export class ListExamsResolver implements Resolve<Exam[]> {
    constructor(private examService: ExamService, private router: Router,
                private alertify: AlertifyService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Exam[]> {
        return this.examService.getExams(1).pipe(
            catchError(error => {
                this.alertify.error('problem retriving data');
                this.router.navigate(['/home']);
                return of(null);
            })
        );
    }
}